// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .hide-small {
    display: none;
    visibility: hidden;
  }
  .show-small {
    display: none;
    visibility: visible !important;
  }
}
.fa-2x {
  font-size: 2em;
}

.fa {
  position: relative;
  display: table-cell;
  width: 60px;
  height: 36px;
  text-align: center;
  vertical-align: middle;
  font-size: 20px;
}

.main-menu:hover {
  width: 250px;
  overflow: visible;
}

a:active {
  background-color: rgb(0, 102, 255);
}

.listmargin {
  margin-top: 15px !important;
}

.dropdownMenu {
  width: 32px;
  float: right;
  margin-right: 20px;
  margin-top: -34px;
}

.main-menu {
  margin-top: 50px;
  background: #191919;
  position: fixed;
  top: 0;
  bottom: 0;
  height: 100%;
  left: 0;
  width: 60px;
  overflow: hidden;
  transition: width 0.05s linear;
  -webkit-transform: translateZ(0) scale(1, 1);
  z-index: 1000;
}

.main-menu > ul {
  margin: 7px 0;
}

.main-menu li {
  position: relative;
  display: block;
  width: 250px;
}

.main-menu li > a {
  position: relative;
  display: table;
  border-collapse: collapse;
  border-spacing: 0;
  color: #ffffff;
  font-family: arial;
  font-size: 14px;
  text-decoration: none;
  -webkit-transform: translateZ(0) scale(1, 1);
  transition: all 0.1s linear;
}

.main-menu .nav-icon {
  position: relative;
  display: table-cell;
  width: 60px;
  height: 36px;
  text-align: center;
  vertical-align: middle;
  font-size: 18px;
}

.main-menu .nav-text {
  position: relative;
  display: table-cell;
  vertical-align: middle;
  width: 190px;
  height: 18px;
  font-weight: 400;
  font-family: "Omnes-ATT-W02";
}

.main-menu > ul.logout {
  position: absolute;
  left: 0;
  bottom: 0;
}

.no-touch .scrollable.hover {
  overflow-y: hidden;
}

.no-touch .scrollable.hover:hover {
  overflow-y: auto;
  overflow: visible;
}

a:hover, a:focus {
  text-decoration: none;
}

nav {
  -webkit-user-select: none;
  -o-user-select: none;
  user-select: none;
}

nav ul, nav li {
  outline: 0;
  margin: 0;
  padding: 0;
}

.main-menu li:hover > a, nav > a, .dropdown-menu > li > a:hover, .dropdown-menu > li > a:focus, .no-touch .dashboard-page nav.dashboard-menu ul li:hover a {
  color: #fff;
  background-color: #434242;
}

.main-menu li:active > a, nav > a, .dropdown-menu > li > a:active, .dropdown-menu > li > a:active, .no-touch .dashboard-page nav.dashboard-menu ul li:active a {
  background-color: #009FDB;
}

.dropdown-menu > .active > a {
  background-color: #009FDB;
}

.dropdown-menu > .active > a:focus {
  background-color: #009FDB;
}

.dashboard-page nav.dashboard-menu ul li.active a {
  background-color: #009FDB;
}

.active {
  background-color: #009FDB;
  color: #fff;
}

.main-menu li.active {
  color: #fff;
  background-color: #009FDB;
}

.area {
  float: left;
  background: #e2e2e2;
  width: 100%;
  height: 100%;
}

.disable-hover {
  pointer-events: none;
}

.sticky {
  position: fixed;
  top: -50px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/menus/menus.component.scss"],"names":[],"mappings":"AAUA;EAEE;IACE,aAAA;IACA,kBAAA;EAVF;EAaA;IACE,aAAA;IACA,8BAAA;EAXF;AACF;AAaA;EACA,cAAA;AAXA;;AAaA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAVA;;AAcA;EACA,YAAA;EACA,iBAAA;AAXA;;AAcA;EACE,kCAAA;AAXF;;AAcA;EACI,2BAAA;AAXJ;;AAcA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAXF;;AAqBA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EAEA,8BAAA;EACA,4CAAA;EACA,aAAA;AAlBA;;AAqBA;EACA,aAAA;AAlBA;;AAqBA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AAlBA;;AAqBA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;EACC,kBAAA;EACD,eAAA;EACA,qBAAA;EACA,4CAAA;EAEA,2BAAA;AAlBA;;AAsBA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAnBA;;AAsBA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,4BAAA;AAnBA;;AAsBA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;AAnBA;;AAsBA;EACA,kBAAA;AAnBA;;AAsBA;EACA,gBAAA;EACA,iBAAA;AAnBA;;AAsBA;EACA,qBAAA;AAnBA;;AAsBA;EACA,yBAAA;EAGA,oBAAA;EACA,iBAAA;AAnBA;;AAsBA;EACA,UAAA;EACA,SAAA;EACA,UAAA;AAnBA;;AAqBA;EACA,WAAA;EACA,yBAAA;AAlBA;;AAqBA;EACE,yBAAA;AAlBF;;AAoBA;EACE,yBAAA;AAjBF;;AAwBA;EACE,yBAAA;AArBF;;AAuBA;EACE,yBAAA;AApBF;;AAsBA;EACI,yBAAA;EACA,WAAA;AAnBJ;;AAqBA;EACA,WAAA;EACA,yBAAA;AAlBA;;AAoBA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAjBA;;AAoBA;EACE,oBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,UAAA;AAjBF","sourcesContent":["\n// .hide-small {\n//   display: none;\n//   visibility: visible !important;\n// }\n\n// .show-small {\n//   display: none;\n//   visibility: hidden;\n//}\n@media (max-width: 1024px) {\n  \n  .hide-small {\n    display: none;\n    visibility: hidden;\n  }\n\n  .show-small {\n    display: none;\n    visibility: visible !important;\n  }\n}\n.fa-2x {\nfont-size: 2em;\n}\n.fa {\nposition: relative;\ndisplay: table-cell;\nwidth: 60px;\nheight: 36px;\ntext-align: center;\nvertical-align: middle;\nfont-size:20px;\n}\n\n\n.main-menu:hover {\nwidth:250px;\noverflow:visible;\n}\n\na:active {\n  background-color: rgb(0, 102, 255);\n}\n\n.listmargin{\n    margin-top: 15px !important;\n}\n\n.dropdownMenu{\n  width: 32px;\n  float: right;\n  margin-right: 20px;\n  margin-top: -34px;\n}\n\n// .dropdownMenu{\n//     width: 15px;\n//     float: right; \n//     margin-right: 30px;\n//     margin-top:-25px ;\n// }\n\n.main-menu {\nmargin-top: 50px;\nbackground:#191919;\nposition:fixed;\ntop:0;\nbottom:0;\nheight:100%;\nleft:0;\nwidth:60px;\noverflow:hidden;\n-webkit-transition:width .05s linear;\ntransition:width .05s linear;\n-webkit-transform:translateZ(0) scale(1,1);\nz-index:1000;\n}\n\n.main-menu>ul {\nmargin:7px 0;\n}\n\n.main-menu li {\nposition:relative;\ndisplay:block;\nwidth:250px;\n}\n\n.main-menu li>a {\nposition:relative;\ndisplay:table;\nborder-collapse:collapse;\nborder-spacing:0;\ncolor:#ffffff;\n font-family: arial;\nfont-size: 14px;\ntext-decoration:none;\n-webkit-transform:translateZ(0) scale(1,1);\n-webkit-transition:all .1s linear;\ntransition:all .1s linear;\n  \n}\n\n.main-menu .nav-icon {\nposition:relative;\ndisplay:table-cell;\nwidth:60px;\nheight:36px;\ntext-align:center;\nvertical-align:middle;\nfont-size:18px;\n}\n\n.main-menu .nav-text {\nposition:relative;\ndisplay:table-cell;\nvertical-align:middle;\nwidth:190px;\nheight: 18px;\nfont-weight: 400;\nfont-family: 'Omnes-ATT-W02';\n}\n\n.main-menu>ul.logout {\nposition:absolute;\nleft:0;\nbottom:0;\n}\n\n.no-touch .scrollable.hover {\noverflow-y:hidden;\n}\n\n.no-touch .scrollable.hover:hover {\noverflow-y:auto;\noverflow:visible;\n}\n\na:hover,a:focus {\ntext-decoration:none;\n}\n\nnav {\n-webkit-user-select:none;\n-moz-user-select:none;\n-ms-user-select:none;\n-o-user-select:none;\nuser-select:none;\n}\n\nnav ul,nav li {\noutline:0;\nmargin:0;\npadding:0;\n}\n.main-menu li:hover>a,nav>a,.dropdown-menu>li>a:hover,.dropdown-menu>li>a:focus,.no-touch .dashboard-page nav.dashboard-menu ul li:hover a {\ncolor:#fff;\nbackground-color:#434242;\n}\n\n.main-menu li:active>a,nav>a,.dropdown-menu>li>a:active,.dropdown-menu>li>a:active,.no-touch .dashboard-page nav.dashboard-menu ul li:active a {\n  background-color:#009FDB;;\n  }\n.dropdown-menu>.active>a{\n  background-color:#009FDB;\n}\n\n// }\n// .dropdown-menu>.active>a:hover{\n\n// }\n.dropdown-menu>.active>a:focus{\n  background-color:#009FDB;\n}\n.dashboard-page nav.dashboard-menu ul li.active a{\n  background-color:#009FDB;\n}\n.active {\n    background-color:#009FDB;\n    color:#fff;\n  }\n.main-menu li.active{\ncolor:#fff;\nbackground-color:#009FDB;\n}\n.area {\nfloat: left;\nbackground: #e2e2e2;\nwidth: 100%;\nheight: 100%;\n}\n\n.disable-hover{\n  pointer-events: none;\n}\n\n.sticky{\n  position: fixed;\n  top: -50px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
